import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import ReadOnlyACLs from "src/components/acl";
import { FullAccessRule } from "src/api/generated/frontend_customer_v1";
import { BadgeButton } from "src/components/base/badges/base";
import SINGLE_SUBNET_CONTEXT from "src/context/customer/subnet";

/**
 * The properties for {@link SubnetInboundACLs}
 */
export type SubnetInboundACLsProps = {};

/**
 * The view to display the Inbound ACLs of a tag
 */
function SubnetInboundACLs(props: SubnetInboundACLsProps) {
    const ctx = React.useContext(SINGLE_SUBNET_CONTEXT);

    const groups: { [key: string]: Array<FullAccessRule> } = {};
    const subnets: { [key: string]: Array<FullAccessRule> } = {};
    const tags: { [key: string]: Array<FullAccessRule> } = {};

    for (const rule of ctx.subnet.access_rules.inbound) {
        if (rule.src.type === "Group") {
            if (groups[rule.src.value.uuid] === undefined) {
                groups[rule.src.value.uuid] = [];
            }
            groups[rule.src.value.uuid].push(rule);
        } else if (rule.src.type === "Tag") {
            if (tags[rule.src.value.uuid] === undefined) {
                tags[rule.src.value.uuid] = [];
            }
            tags[rule.src.value.uuid].push(rule);
        } else if (rule.src.type === "Subnet") {
            if (subnets[rule.src.value.uuid] === undefined) {
                subnets[rule.src.value.uuid] = [];
            }
            subnets[rule.src.value.uuid].push(rule);
        }
    }

    return (
        <div className={"flex flex-col gap-6"}>
            {Object.entries(groups).map(([key, value]) => (
                <div key={key} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/c/groups/$groupId/outbound-acls"}
                        params={{ groupId: key }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`group:${value[0].src.value.name}`}
                    </BadgeButton>
                    <ReadOnlyACLs rules={value} />
                </div>
            ))}

            {Object.entries(tags).map(([key, value]) => (
                <div key={key} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/c/tags/$tagId/outbound-acls"}
                        params={{ tagId: key }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`tag:${value[0].src.value.name}`}
                    </BadgeButton>
                    <ReadOnlyACLs rules={value} />
                </div>
            ))}

            {Object.entries(subnets).map(([key, value]) => (
                <div key={key} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/c/subnets/$subnetId/outbound-acls"}
                        params={{ subnetId: key }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`subnet:${value[0].src.value.name}`}
                    </BadgeButton>
                    <ReadOnlyACLs rules={value} />
                </div>
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_customer/c/subnets/$subnetId/_subnet/inbound-acls")({
    component: SubnetInboundACLs,
});
